export const CompanyStore = {
  leanLawApi: undefined
};
export default class Company {
  constructor(leanLawApi) {
    this.leanLawApi = leanLawApi;
    if (!CompanyStore.leanLawApi) {
      CompanyStore.leanLawApi = leanLawApi;
    }
  }
  load(json) {
    const company = this;
    angular.copy(json, company);
    company.$original = json;
    if (!company.settings.references || !company.settings.references.pattern) {
      company.settings.references = {
        pattern: 'custom',
        nextNumber: 1
      };
    }
    return this;
  }
  update(update) {
    const company = this;
    return CompanyStore.leanLawApi.updateMyCompany({
      body: update || company
    }).then(updated => company.load(updated));
  }
}